// Universal Checkout Loading - Works with Bold Commerce
(function() {
  // Inject styles IMMEDIATELY on script load (not on first click)
  if (!document.getElementById('universal-loading-styles')) {
    const styles = document.createElement('style');
    styles.id = 'universal-loading-styles';
    styles.innerHTML = `
      /* Button loading state with spinner */
      .checkout-button-loading {
        position: relative !important;
        color: transparent !important;
        /* REMOVED pointer-events: none - was blocking form submission */
      }
      
      .checkout-button-loading::after {
        content: "";
        position: absolute;
        width: 20px;
        height: 20px;
        top: 50%;
        left: 50%;
        margin-left: -10px;
        margin-top: -10px;
        border: 2px solid rgba(255,255,255,0.3);
        border-top-color: white;
        border-radius: 50%;
        animation: checkout-spin 0.6s linear infinite;
      }
      
      @keyframes checkout-spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(styles);
  }
  
  // Global loading function - available IMMEDIATELY
  window.triggerCheckoutLoading = function() {
    
    // Find and disable ALL checkout buttons (including Bold's and hidden ones)
    const checkoutButtons = document.querySelectorAll(
      '#checkout, ' +
      '[name="checkout"], ' +
      '.cart__checkout-button, ' +
      'button[type="submit"][name="checkout"], ' +
      '.bold_checkout, ' +
      '.bold-checkout, ' +
      '[data-checkout-button], ' +
      '[data-bold-checkout], ' +
      'button[form="cart"], ' +
      '.checkout-button'  // Generic checkout button class
    );
    
    checkoutButtons.forEach(btn => {
      btn.classList.add('checkout-button-loading');
    });
    
    // Also disable Bold's checkout if it exists
    if (window.BOLD && window.BOLD.checkout) {
      // Bold Commerce detected
    }
    
    // Safety timeout
    setTimeout(function() {
      checkoutButtons.forEach(btn => {
        btn.classList.remove('checkout-button-loading');
      });
    }, 15000);
  };
  
  // Intercept ALL checkout attempts
  function setupInterceptors() {
    // 1. Original checkout button - let Bold hide it if needed
    const checkoutBtn = document.getElementById('checkout');
    if (checkoutBtn) {
      // Add IMMEDIATE mousedown handler (fires before click)
      checkoutBtn.addEventListener('mousedown', function(e) {
        if (e.button === 0 && !this.disabled) { // Left click only
          window.triggerCheckoutLoading();
        }
      }, true);
      
      // Also keep onclick handler as backup
      const originalOnclick = checkoutBtn.onclick;
      checkoutBtn.onclick = function(e) {
        if (!this.disabled) {
          window.triggerCheckoutLoading();
          if (originalOnclick) originalOnclick.call(this, e);
        }
      };
    }
    
    // 2. Intercept form submission
    const cartForm = document.getElementById('cart') || document.querySelector('form[action*="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function(e) {
        const activeBtn = document.activeElement;
        if (activeBtn && (activeBtn.name === 'checkout' || activeBtn.id === 'checkout')) {
          window.triggerCheckoutLoading();
        }
      }, true);
    }
    
    // 3. Watch for Bold Commerce buttons and attach handlers immediately
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Check if it's a Bold checkout button
            if (node.classList && (
              node.classList.contains('bold_checkout') ||
              node.classList.contains('bold-checkout') ||
              node.getAttribute('data-bold-checkout')
            )) {
              // Add mousedown for immediate response
              node.addEventListener('mousedown', function(e) {
                if (e.button === 0 && !this.disabled) {
                  window.triggerCheckoutLoading();
                }
              }, true);
              
              // Also add click handler
              node.addEventListener('click', function() {
                if (!this.disabled) {
                  window.triggerCheckoutLoading();
                }
              });
            }
            
            // Also check children of added nodes
            if (node.querySelectorAll) {
              const boldButtons = node.querySelectorAll('.bold_checkout, .bold-checkout, [data-bold-checkout]');
              boldButtons.forEach(function(btn) {
                btn.addEventListener('mousedown', function(e) {
                  if (e.button === 0 && !this.disabled) {
                    window.triggerCheckoutLoading();
                  }
                }, true);
                
                btn.addEventListener('click', function() {
                  if (!this.disabled) {
                    window.triggerCheckoutLoading();
                  }
                });
              });
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Initialize when ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupInterceptors);
  } else {
    setTimeout(setupInterceptors, 100);
  }
  
  // AGGRESSIVE: Catch ANY click on checkout buttons using event delegation
  document.addEventListener('mousedown', function(e) {
    const target = e.target;
    
    // Check if clicked element or any parent is a checkout button
    let checkoutBtn = null;
    let currentElement = target;
    
    // Walk up the DOM tree to find checkout button
    while (currentElement && !checkoutBtn) {
      if (currentElement.id === 'checkout' ||
          currentElement.name === 'checkout' ||
          (currentElement.classList && (
            currentElement.classList.contains('cart__checkout-button') ||
            currentElement.classList.contains('bold_checkout') ||
            currentElement.classList.contains('bold-checkout')
          )) ||
          currentElement.getAttribute('data-bold-checkout') ||
          (currentElement.type === 'submit' && currentElement.name === 'checkout')) {
        checkoutBtn = currentElement;
      }
      currentElement = currentElement.parentElement;
    }
    
    if (checkoutBtn && e.button === 0 && !checkoutBtn.disabled) {
      window.triggerCheckoutLoading();
    }
  }, true); // Use capture phase to catch event early
  
  // Also catch click events
  document.addEventListener('click', function(e) {
    const target = e.target;
    
    // Check if clicked element or any parent is a checkout button
    let checkoutBtn = null;
    let currentElement = target;
    
    // Walk up the DOM tree to find checkout button
    while (currentElement && !checkoutBtn) {
      if (currentElement.id === 'checkout' ||
          currentElement.name === 'checkout' ||
          (currentElement.classList && (
            currentElement.classList.contains('cart__checkout-button') ||
            currentElement.classList.contains('bold_checkout') ||
            currentElement.classList.contains('bold-checkout')
          )) ||
          currentElement.getAttribute('data-bold-checkout') ||
          (currentElement.type === 'submit' && currentElement.name === 'checkout')) {
        checkoutBtn = currentElement;
      }
      currentElement = currentElement.parentElement;
    }
    
    if (checkoutBtn && !checkoutBtn.disabled) {
      window.triggerCheckoutLoading();
    }
  }, true); // Use capture phase
  
  // Still setup specific handlers after Bold loads
  setTimeout(function() {
    // Re-run setup to catch any dynamically added elements
    setupInterceptors();
    
    // Find all checkout buttons including Bold's
    const allCheckoutButtons = document.querySelectorAll(
      '#checkout, [name="checkout"], .cart__checkout-button, ' +
      '.bold_checkout, .bold-checkout, [data-bold-checkout], ' +
      'button[type="submit"][name="checkout"]'
    );
    
    allCheckoutButtons.forEach(function(btn) {
      // Ensure handlers are attached
      if (!btn.hasLoadingHandler) {
        btn.hasLoadingHandler = true;
        
        btn.addEventListener('mousedown', function(e) {
          if (e.button === 0 && !this.disabled) {
            window.triggerCheckoutLoading();
          }
        }, true);
        
        btn.addEventListener('click', function() {
          if (!this.disabled) {
            window.triggerCheckoutLoading();
          }
        });
      }
    });
  }, 2000); // After Bold should have loaded
})();